//store/index.ts
import { configureStore, combineReducers } from '@reduxjs/toolkit';
import { persistStore } from 'redux-persist';
import localForage from 'localforage';

import { googleAnalyticsReducer } from './useGoogleAnalytics';

// Lock localForage to IndexedDB for best at-rest protection in browsers
localForage.config({
  name: `EmprendiTicoB2BDB`,
  storeName: `EmprendiTicoB2B_fortress`,
  description: `EmprendiTicoB2B app state`,
});

const rootReducer = combineReducers({
  //security: persistReducer(securityPersistConfig, securityReducer),
  googleAnalytics: googleAnalyticsReducer,
});

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefault) =>
    getDefault({
      serializableCheck: {
        ignoredActions: [
          'persist/PERSIST',
          'persist/REHYDRATE',
          'persist/FLUSH',
          'persist/PAUSE',
          'persist/PURGE',
          'persist/REGISTER',
        ],
      },
    }),
});

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;